import { j as d } from "../../../jsx-runtime-B3iL8JI7.js";
import { useEffect as H, useState as c, useRef as k, useImperativeHandle as ue, useMemo as J } from "react";
import * as b from "react-datepicker";
import { getMonth as O, getYear as x, getDate as fe, format as me } from "date-fns";
import { dateToString as A } from "./helpers/dateToString.js";
import pe from "./subcomponents/DatePickerHeader.js";
import { formatDate as de } from "./helpers/formatDate.js";
import we from "./helpers/useDynamicCalendarStyle.js";
import { isBetweenDateRange as ge } from "./helpers/isBetweenDateRange.js";
import { isCurrentMonth as De } from "./helpers/isCurrentMonth.js";
import { isWeekday as K } from "./helpers/isWeekday.js";
import "../../atoms/Button/Button.styles.js";
import "@fortawesome/pro-duotone-svg-icons";
import "@fortawesome/react-fontawesome";
import "../../atoms/Icon/Icon.utilities.js";
import "../../atoms/Icon/Icon.styles.js";
import "../../../tailwindConfig/bclTwMerge.js";
import Me from "../../../utilities/groupBy.js";
import ve from "../../../utilities/tw.js";
import "@radix-ui/react-checkbox";
import "../../atoms/Checkbox/Checkbox.styles.js";
import "@fortawesome/pro-solid-svg-icons";
import "../../atoms/Loader/SYFLoader/SyfLoader.js";
import "../../atoms/ProgressIndicator/ProgressIndicator.styles.js";
import "@radix-ui/react-select";
import ye from "../../atoms/TextField/TextField.js";
import "../../atoms/TextLink/TextLink.styles.js";
import "../../atoms/Chip/Chip.styles.js";
import "@radix-ui/react-radio-group";
import "../../atoms/RadioItem/RadioItem.styles.js";
import '../../../assets/DatePicker.css';const Te = (o, s) => {
  H(() => {
    const l = (f) => {
      o.current && !o.current.contains(f.target) && s();
    };
    return document.addEventListener("mousedown", l), () => {
      document.removeEventListener("mousedown", l);
    };
  }, [s, o]);
}, Ce = (o, s) => {
  const [l, f] = c({
    topThresholdMet: !1,
    rightThresholdMet: !1,
    bottomThresholdMet: !1,
    leftThresholdMet: !1
  }), {
    topThreshold: w = 0,
    rightThreshold: h = 0,
    bottomThreshold: g = 0,
    leftThreshold: D = 0
  } = s;
  return H(() => {
    const r = () => {
      if (!o.current) return;
      const i = o.current.getBoundingClientRect(), m = i.top, E = window.innerWidth - i.right, R = window.innerHeight - i.bottom, P = i.left;
      f({
        topThresholdMet: m < w,
        rightThresholdMet: E < h,
        bottomThresholdMet: R < g,
        leftThresholdMet: P < D
      });
    };
    return r(), window.addEventListener("resize", r), window.addEventListener("scroll", r), () => {
      window.removeEventListener("resize", r), window.removeEventListener("scroll", r);
    };
  }, [g, D, o, h, w]), l;
}, Ye = b.default.default || b.default || b, et = ({
  className: o,
  disabled: s,
  errorText: l,
  helperIcon: f,
  helperText: w,
  id: h,
  inputRef: g,
  label: D,
  minDate: r,
  maxDate: i,
  onBlur: m,
  onChange: E,
  placeholder: R,
  required: P = !0,
  excludeDates: a = [],
  excludeWeekends: N = !1,
  value: p,
  zIndex: Q = "auto",
  disableKeyboard: B = !1
}) => {
  const V = new Date(p ?? /* @__PURE__ */ new Date()), [I, M] = c(A(p)), [X, v] = c(p), [L, y] = c(!1), [T, W] = c(!1), [$, Z] = c(O(V)), [F, _] = c(x(V)), z = k(null), U = k(null), j = k(null), q = k(!1);
  we({ id: h, zIndex: Q }), ue(g, () => j.current), Te(z, () => y(!1)), H(() => {
    var e;
    !L && q.current && ((e = j.current) == null || e.focus()), q.current = !0;
  }, [L]);
  const { bottomThresholdMet: ee, rightThresholdMet: te } = Ce(
    U,
    { bottomThreshold: 300, rightThreshold: 170 }
  ), re = ve`absolute ${te ? "right-0" : "-right-44"} ${ee ? "-top-72" : "top-16"}`, G = J(() => {
    const e = /^\d{4}-\d{2}-\d{2}$/, t = a.every((u) => e.test(u)), n = "Invalid excludeDates format. Use YYYY-MM-DD.";
    if (!t) throw new Error(n);
    return a.map((u) => {
      const [Y, S, he] = u.split("-").map(Number);
      return new Date(Y, S - 1, he);
    });
  }, [a]), oe = J(() => Me(G, (t) => `${x(t)}/${O(t)}`), [G]), ne = (e) => {
    const t = [], n = me(e, "yyyy-MM-dd");
    return N && t.push(!K(e)), a != null && a.length && t.push(a.includes(n)), t.some(Boolean);
  }, se = (e) => T ? !0 : [
    // prevent selecting days outside of current selected month
    De(e, $),
    // prevent selecting weekends
    N ? K(e) : !0
    // ? Note: holidays select are disabled and handled through the excluded days props from react-datepicker
  ].every(Boolean), C = (e) => {
    const t = F, n = $;
    if (!T) {
      M(A(e)), y(!1), E(e), v(e);
      return;
    }
    if (e) {
      const u = ge(e, r, i), Y = new Date(t, n, fe(e ?? "1")), S = e.getFullYear();
      u && (Y.setFullYear(S), e = Y), !u && r && (e = r), v(e);
    }
    W(!1);
  }, ie = (e) => {
    const t = de(e.currentTarget.value), n = new Date(t);
    if (M(t), t.length === 0 && C(null), t.length === 10) {
      if (ne(n)) return C(null);
      C(n);
    }
  }, ae = (e) => {
    const t = A(p);
    t && (M(t), v(p)), t || v(null), m == null || m(e);
  }, ce = (e) => {
    if (B) {
      e.preventDefault();
      return;
    }
    e.key === "Backspace" && I.endsWith("/") && (e.preventDefault(), M(I.slice(0, -2)));
  }, le = (e) => {
    Z(O(e)), _(x(e));
  };
  return /* @__PURE__ */ d.jsxs("div", { className: "relative w-full", ref: U, children: [
    /* @__PURE__ */ d.jsx(
      ye,
      {
        className: o,
        disabled: s,
        errorText: l,
        helperIcon: f,
        helperText: w,
        id: h,
        inputRef: j,
        label: D,
        onBlur: ae,
        onChange: ie,
        onKeyDown: ce,
        placeholder: R,
        required: P,
        rightCta: {
          content: "calendar",
          onClick: () => {
            y((e) => !e);
          },
          iconLabel: "Open Date Picker",
          type: "icon",
          className: "hover:text-primary"
        },
        value: I,
        style: B ? { cursor: "pointer" } : void 0,
        onClick: () => {
          B && y(!0);
        }
      }
    ),
    L && !s && /* @__PURE__ */ d.jsx(
      "div",
      {
        id: `${h}-datePickerCalendar`,
        ref: z,
        className: re,
        children: /* @__PURE__ */ d.jsx(
          Ye,
          {
            selected: X,
            inline: !0,
            onSelect: C,
            filterDate: se,
            excludeDates: oe[`${F}/${$}`],
            maxDate: i,
            minDate: r,
            renderCustomHeader: (e) => /* @__PURE__ */ d.jsx(
              pe,
              {
                ...e,
                onDateChange: le,
                isYearSelect: T,
                setIsYearSelect: W
              }
            ),
            showMonthDropdown: !0,
            formatWeekDay: (e) => e[0],
            showYearPicker: T
          }
        )
      }
    )
  ] });
};
export {
  et as default
};
